import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { name: "Admin Pannel", path: "/admin" },
    { name: "Users", path: "/admin/users" },
    { name: "Guards", path: "/admin/guards" },
    { name: "Society", path: "/admin/society" },
    { name: "Vistior", path: "/admin/reports" },
    { name: "Create Staff", path: "/admin/createstaff" },
    { name: "All staff", path: "/admin/allstaff" },
    { name: "Staff Attendence", path: "/admin/staffAttendence" },
  ];

  return (
    <div className="sidebar">
      <ul>
        {menuItems.map((item) => (
          <li
            key={item.path}
            className={location.pathname === item.path ? "active" : ""}
            onClick={() => navigate(item.path)}
          >
            {item.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
